<template>
	<div class="container" style="background-color:#fffcf7;">
		<headMenu />
		<div class="text-center">
			<img
				alt="تماس با ما شرکت فناوری  رهنمای دنیای آینده (فردا)"
				title="تماس با ما شرکت فناوری  رهنمای دنیای آینده (فردا)"
				:src="require('../../../assets/img/Shape_Title.svg')"
				data-aos="fade-up"
				data-aos-duration="3000"
			/>
			<p class="bMikhak text-center text-success" style="font-size: 24px;">
				تماس با ما
			</p>
			<p class="text-center" style="">
				شرکت فناوری  رهنمای دنیای آینده (فردا)
			</p>
		</div>
		<div class="row mt-3 bg-white shadow p-5 border-15">
	     <div class="col-sm-12 col-md-12 col-lg-7 col-xl-7 p-3" :style=" (windowWidth>990) ? 'border-left: 1px solid #1b60c6;' : 'border-bottom: 1px solid #1b60c6;' ">
				 <p style="color: #1b60c6; font-weight: bold; font-size: 24px;">
					 ارسال پیام
				 </p>
				 <textInput class="mt-3" autofocus="true" @inputTxtFunc="fullnameF" :val="val.fullname" placeholder="نام و نام خانوادگی" label="نام و نام خانوادگی" />
				 <textInput 
				 	class="mt-3" 
					@inputTxtFunc="mail_or_mobileF" 
					:val="val.mail_or_mobile" 
					textClass="" 
					placeholder="تلفن تماس یا آدرس ایمیل"  
					label="تلفن تماس یا آدرس ایمیل" 
				/>
				
				 <textareaInput class="mt-3" @inputTxtFunc="textF" :value="val.text" placeholder="پیام خود را بنویسید" label="پیام خود را بنویسید" style_input="height: 265px;" />
				 <btn  @clickMe="sav()" class="w-100 mt-5 " :class=" (windowWidth>990) ? '' : 'mb-5' " textClass="w-100" text="ارسال پیام" />
	     </div>
	     <div class="col-sm-12 col-md-12 col-lg-5 col-xl-5 p-3" :class=" (windowWidth>990) ? '' : 'mt-5' ">
				 <p style="color: #1b60c6; font-weight: bold; font-size: 24px;">
					 تماس با ما
				 </p>
				 <p class="" style="color: #1b60c6; font-weight: bold; font-size: 24px;">
					 <img
					 class="w-50"
					 alt="تماس با ما شرکت فناوری  رهنما  دنیای آینده (فردا)"
					 title="تماس با ما شرکت فناوری  رهنما  دنیای آینده (فردا)"
					 :src="require('../../../assets/img/Logo_Header.svg')"
					 />
				 </p>
				 <p class="m-0" style="font-size: 20px;">
					 <img
					 width="20"
					 alt="تماس با ما شرکت فناوری  رهنما  دنیای آینده (فردا)"
					 title="تماس با ما شرکت فناوری  رهنما  دنیای آینده (فردا)"
					 :src="require('../../../assets/img/phone-call.svg')"
					 />
					 تلفن:
				 </p>
				 <p class="text-left ">
					021-88625168
					 <br />
					 021-88618512
					 <br />
					 021-88047153
					 <br />
					 021-88063416
					 <br />
					 021-88607815
				 </p>
				 <!-- ------------------------------------------------------------ -->
				 <p class="mt-3 mb-0" style="font-size: 20px;">
					 <img
					 width="20"
					 alt="تماس با ما شرکت فناوری  رهنما  دنیای آینده (فردا)"
					 title="تماس با ما شرکت فناوری  رهنما  دنیای آینده (فردا)"
					 :src="require('../../../assets/img/mail.svg')"
					 />
					 ایمیل:
				 </p>
				 <p class="text-left ">
					 info@ostadbin.com
				 </p>
				 <!-- ------------------------------------------------------------ -->
				 <div style="font-size: 20px;"  class="m-0">
					 <img
					 width="20"
					 alt="تماس با ما شرکت فناوری  رهنما  دنیای آینده (فردا)"
					 title="تماس با ما شرکت فناوری  رهنما  دنیای آینده (فردا)"
					 :src="require('../../../assets/img/address.svg')"
					 />
					 آدرس شرکت:
				 </div>
				 <div class="text-justify ">
					خیابان شیراز جنوبی، بلوار آقا علیخانی شرقی پلاک2 طبقه 2 فناوری رهنمای دنیای آینده (فردا)					
				 </div>
				 <!-- ------------------------------------------------------------ -->
				 <p style="font-size: 20px;"  class="m-0">
					 <img
					 width="20"
					 alt="تماس با ما شرکت فناوری  رهنما  دنیای آینده (فردا)"
					 title="تماس با ما شرکت فناوری  رهنما  دنیای آینده (فردا)"
					 :src="require('../../../assets/img/location2.svg')"
					 />
					 موقعیت جغرافیایی:
				 </p>
				 <iframe
				  class="w-100 border-15" height="200"
				 src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d202.3775801947331!2d51.40313115288616!3d35.74979005321269!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2s!4v1720350408294!5m2!1sen!2s" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
	     </div>
	   </div>
		<footerPage  />
	</div>
</template>

<script>
	import textInput from  "../../../UI/input/textInput.vue";
	import textareaInput from  "../../../UI/input/textareaInput.vue";
	import footerPage from  "../../../UI/footer/footer.vue";
	import back from  "../../../UI/back/back.vue";
	import btn from  "../../../UI/button/btn.vue";
	import headMenu from  "../../../menu/headMenu.vue";
	import { validateEmail, validatePhone, indexFinder } from  "../../../assets/library/filter.js";
	import leftMenuPublic from  "../../../menu/leftMenuPublic.vue";


	export default {
			name: 'teachers_id',
		data(){
			return {
				validateEmail: validateEmail,
				validatePhone: validatePhone,
				indexFinder: indexFinder,
				imgurl: window.imgurl,
				baseurl: window.baseurl,
				flds: [],
				degrees: [],
				category: [],
				location: [],
				img:{
				},
				val:{
					"fullname": "",
					"email": "",
					"mobile": "",
					"text": "",
					"mail_or_mobile" : "",
				},
				index_text : -1

			}
		},
		components: {
				validateEmail,
				leftMenuPublic,
				btn,
				textInput,
				textareaInput,
				back,
				headMenu,
				footerPage,
		},
			props: [],
		mounted(){
			this.$swal.close();
			this.loader();
			this.index_text = this.indexFinder(this.$localStorage.get('settings'), "15");
		},
		methods:{
			sav(THIS=this){
				if(this.val.fullname=="" || this.val.mail_or_mobile=="" || this.val.text==""){
					THIS.$swal.fire({
							position: 'center',
							type: 'error',
							title: 'اطلاعات را تکمیل نمایید',
							timer: '1000',
							showConfirmButton: false
					});
				} else if((!this.validateEmail(this.val.email) && this.val.email!="") || (this.validatePhone(this.val.mobile)==false && this.val.mobile!="")){
					THIS.$swal.fire({
							position: 'center',
							type: 'error',
							title: 'شماره تماس  یا ایمیل اشتباه است',
							timer: '1000',
							showConfirmButton: false
					});
				} else {
					window.$.post(this.baseurl + 'view/comment', { token: this.$localStorage.get("user"), fullname: this.val.fullname, email: this.val.email, mobile: this.val.mobile, text: this.val.text }, function(D){
						THIS.$swal.fire({
								position: 'center',
								type: 'success',
								title: 'ثبت شد',
								timer: '1000',
								showConfirmButton: false
						});
							THIS.val.fullname="";
							THIS.val.email="";
							THIS.val.mobile="";
							THIS.val.text="";
					}, "json");
				}
			},
			// *********************************************************************
			fullnameF(e){
				this.val.fullname = e;
			},
			// *********************************************************************
			mobileF(e){
				this.val.mobile = e;
			},
			// *********************************************************************
			emailF(e){
				this.val.email = e;
			},
			// *********************************************************************
			mail_or_mobileF(e){
				this.val.mail_or_mobile = e;
				this.val.mobile = "";
				this.val.email = "";
				if(this.validatePhone(this.val.mail_or_mobile)){
					this.val.mobile = this.val.mail_or_mobile;
				} else {
					this.val.email = this.val.mail_or_mobile;
				}
			},
			// *********************************************************************
			textF(e){
				this.val.text = e;
			},
			// *********************************************************************
			loader(THIS=this){
				window.$.get(this.baseurl+'view/teachers/'+this.$route.params.id, { }, function(D){
					THIS.flds = D;
				}, "json");
			}
				// *********************************************************************
		}
	}
</script>
<style>

</style>
